'use client';

import classnames from 'classnames';
import dayjs from '@lib/dayjs';
import { useEffect, useState } from 'react';
import { QA_LOCALIZED_DATE } from '@test-config/testIds';
import { LocalizedDateProps } from './localizedDate.types';
import styles from './localizedDate.module.scss';

const LocalizedDate = ({
  format,
  locale,
  date,
  testId = QA_LOCALIZED_DATE.COMPONENT,
  classNames = [],
  nativeProps = {},
}: LocalizedDateProps) => {
  const [isClient, setIsClient] = useState(false);
  const djs = dayjs(locale);
  const classes = classnames([styles.localizedDate], classNames);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return isClient ? (
    <span {...nativeProps} className={classes} data-testid={testId}>
      {format === 'z'
        ? djs(date)
            .locale(locale)
            .tz(djs.tz.guess())
            .format('zzz')
            .match(/\b(\w)/g)
            ?.join('')
        : djs(date).locale(locale).tz(djs.tz.guess()).format(format)}
    </span>
  ) : null;
};

export default LocalizedDate;
